<template>
  <div class="contactUs mainContainer">
    <div class="title">江苏易用科技有限公司</div>
    <div class="contactWay">
      <img src="../../assets/img/public/icon_add.png">
      <span>苏州市相城区太阳路2266号清华大学苏州汽车研究院六楼</span>
    </div>
    <div class="contactWay">
      <img src="../../assets/img/public/icon_phone.png">
      <span>0512-6683 6609&emsp;&emsp;13812614616</span>
    </div>
    <div class="contactWay">
      <img src="../../assets/img/public/icon_email.png">
      <span>eyongtech@163.com</span>
    </div>
    <div>
      <div style="width:100%;height:360px;border:#ccc solid 1px;" id="dituContent"></div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  // 标注点数组
  const markerArr = [{
    title: "江苏易用科技有限公司",
    content: "电话：0512-6683&nbsp;6609&nbsp;&nbsp;&nbsp;<br/><br/>邮箱：eyongtech@163.com",
    point: "120.692011|31.480028",
    isOpen: 0,
    icon: {w: 23, h: 25, l: 46, t: 21, x: 9, lb: 12}
  }
  ]
  export default {
    name: 'contactUs',
    data () {
      return {

      }
    },
    mounted () {
      this.createMap();//创建地图
      this.setMapEvent();//设置地图事件
      this.addMapControl();//向地图添加控件
      this.addMarker();//向地图中添加marker
    },
    methods: {
      createMap () {
        var map = new BMap.Map("dituContent");//在百度地图容器中创建一个地图
        var point = new BMap.Point(120.691383, 31.479601);//定义一个中心点坐标
        map.centerAndZoom(point, 17);//设定地图的中心点和坐标并将地图显示在地图容器中
        window.map = map;//将map变量存储在全局
      },
      // 地图事件设置函数：
      setMapEvent () {
        map.enableDragging();//启用地图拖拽事件，默认启用(可不写)
        map.enableScrollWheelZoom();//启用地图滚轮放大缩小
        map.enableDoubleClickZoom();//启用鼠标双击放大，默认启用(可不写)
        map.enableKeyboard();//启用键盘上下左右键移动地图
      },
      addMapControl () {
        //向地图中添加缩放控件
        var ctrl_nav = new BMap.NavigationControl({anchor: BMAP_ANCHOR_TOP_LEFT, type: BMAP_NAVIGATION_CONTROL_LARGE});
        map.addControl(ctrl_nav);
        //向地图中添加缩略图控件
        var ctrl_ove = new BMap.OverviewMapControl({anchor: BMAP_ANCHOR_BOTTOM_RIGHT, isOpen: 1});
        map.addControl(ctrl_ove);
        //向地图中添加比例尺控件
        var ctrl_sca = new BMap.ScaleControl({anchor: BMAP_ANCHOR_BOTTOM_LEFT});
        map.addControl(ctrl_sca);
      },
      addMarker () {
        console.log(markerArr)
        for (var i = 0; i < markerArr.length; i++) {
          var json = markerArr[i];
          var p0 = json.point.split("|")[0];
          var p1 = json.point.split("|")[1];
          var point = new BMap.Point(p0, p1);
          var iconImg = this.createIcon(json.icon);
          var marker = new BMap.Marker(point, {icon: iconImg});
          var iw = this.createInfoWindow(i);
          var label = new BMap.Label(json.title, {"offset": new BMap.Size(json.icon.lb - json.icon.x + 10, -20)});
          marker.setLabel(label);
          map.addOverlay(marker);
          label.setStyle({
            borderColor: "#808080",
            color: "#333",
            cursor: "pointer"
          });

          (function () {
            var index = i;
            var _iw = this.createInfoWindow(i);
            var _marker = marker;
            _marker.addEventListener("click", function () {
              this.openInfoWindow(_iw);
            });
            _iw.addEventListener("open", function () {
              _marker.getLabel().hide();
            })
            _iw.addEventListener("close", function () {
              _marker.getLabel().show();
            })
            label.addEventListener("click", function () {
              _marker.openInfoWindow(_iw);
            })
            if (!!json.isOpen) {
              label.hide();
              _marker.openInfoWindow(_iw);
            }
          })()
        }
      },
      createInfoWindow(i) {
        console.log(123)
        var json = markerArr[i];
        var iw = new BMap.InfoWindow("<b class='iw_poi_title' title='" + json.title + "'>" + json.title + "</b><div class='iw_poi_content'>" + json.content + "</div>");
        return iw;
      },
      createIcon (json) {
        var icon = new BMap.Icon("http://api.map.baidu.com/lbsapi/creatmap/images/us_mk_icon.png", new BMap.Size(json.w, json.h), {
          imageOffset: new BMap.Size(-json.l, -json.t),
          infoWindowOffset: new BMap.Size(json.lb + 5, 1),
          offset: new BMap.Size(json.x, json.h)
        })
        return icon;
      }
    }
  }
</script>

<style scoped>
.contactUs{
  width: 1200px;
}
  .title{
    color: #333333;
    font-size: 24px;
    font-weight: bold;
    margin: 24px 0;
  }
  .contactWay{
    margin-bottom: 22px;
  }
  img{
    width: 30px;
    height: 30px;
    vertical-align: middle;
    margin-right: 10px;
  }
  span{
    color: #333333;
    font-size: 18px;
    vertical-align: middle;
  }
</style>
